import { Reveal } from "@components/ui";

interface FeeItem {
  title: string;
  description: string;
  price: string;
  frequency: string;
  badgeColor: string;
  badgeTextColor: string;
}

const feeItems: FeeItem[] = [
  {
    title: "Monthly Service Charge (Billing & Meter Maintenance)",
    description:
      "Covers billing, collection, portal access, and meter maintenance",
    price: "TBC",
    frequency: "Monthly",
    badgeColor: "#f24d2b",
    badgeTextColor: "#fff",
  },
  {
    title: "Smart Meter Connection Fee",
    description: "Applies on initial activation of smart meter",
    price: "TBC",
    frequency: "One-time",
    badgeColor: "#c9e0ff",
    badgeTextColor: "#090d2c",
  },
  {
    title: "Account Setup / Administration Fee",
    description: "Payable upon new account registration or move-in",
    price: "TBC",
    frequency: "One-time",
    badgeColor: "#c9e0ff",
    badgeTextColor: "#090d2c",
  },
  {
    title: "Late Payment Fee",
    description: "Applied automatically to overdue payments",
    price: "TBC",
    frequency: "Per Invoice",
    badgeColor: "#851700",
    badgeTextColor: "#fff",
  },
  {
    title: "Security Deposit",
    description: "Refundable upon final settlement (see table below)",
    price: "TBC",
    frequency: "One-time",
    badgeColor: "#c9e0ff",
    badgeTextColor: "#090d2c",
  },
  {
    title: "Final Bill Processing Fee",
    description: "Applied when closing an account",
    price: "TBC",
    frequency: "One-time",
    badgeColor: "#c9e0ff",
    badgeTextColor: "#090d2c",
  },
  {
    title: "Reconnection Fee",
    description: "After default, arrears, or safety disconnection",
    price: "TBC",
    frequency: "As applicable",
    badgeColor: "#62636c",
    badgeTextColor: "#fff",
  },
  {
    title: "Disconnection Fee (Voluntary)",
    description: "For customer-requested disconnection",
    price: "TBC",
    frequency: "As applicable",
    badgeColor: "#62636c",
    badgeTextColor: "#fff",
  },
  {
    title: "Urgent Call-Out / False Alarm Fee",
    description: "Non-LPG or false emergency call",
    price: "TBC",
    frequency: "As applicable",
    badgeColor: "#62636c",
    badgeTextColor: "#fff",
  },
  {
    title: "Special Inspection Fee (Non-Routine)",
    description: "For off-cycle inspections requested by customer",
    price: "TBC",
    frequency: "As applicable",
    badgeColor: "#62636c",
    badgeTextColor: "#fff",
  },
  {
    title: "NOC / Clearance Letter",
    description: "For move-out or ownership transfer",
    price: "TBC",
    frequency: "As applicable",
    badgeColor: "#62636c",
    badgeTextColor: "#fff",
  },
  {
    title: "Returned Cheque Fee / Bank Charge",
    description: "All bank and gateway fees borne by customer",
    price: "At cost",
    frequency: "Per transaction",
    badgeColor: "#851700",
    badgeTextColor: "#fff",
  },
];

export function StandardFeesSection() {
  return (
    <section className="w-full bg-white overflow-hidden py-8 md:py-12 lg:py-[80px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto flex flex-col gap-6 md:gap-8 lg:gap-10">
        <Reveal direction="up">
          <div className="flex flex-col items-center gap-3 md:gap-4 text-center">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#122d63]/8 text-[#122d63] text-[13px] md:text-[15px] font-semibold tracking-[-0.02em] uppercase font-albert-sans">
              Fees
            </span>
            <h2 className="text-[24px] md:text-[40px] lg:text-[54px] tracking-[-0.04em] font-semibold text-[#122d63] font-albert-sans leading-[1.1]">
              Standard Fees
            </h2>
          </div>
        </Reveal>

        <div className="flex flex-col gap-0 max-w-[1217px] mx-auto w-full">
          {feeItems.map((fee, index) => (
            <Reveal key={fee.title} direction="up" delay={index * 40}>
              <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6 p-4 md:py-5 md:px-6 border-b border-[#62636C33] border-l-[3px] border-l-transparent hover:border-l-[#f24d2b] hover:bg-[#f8f9fb] transition-all duration-200 group">
                <div className="flex-1 min-w-0">
                  <h3 className="text-[16px] md:text-[20px] lg:text-[28px] tracking-[-0.04em] font-semibold text-[#1c1c1c] font-albert-sans">
                    {fee.title}
                  </h3>
                  <p className="text-[14px] md:text-base lg:text-[24px] tracking-[-0.04em] text-[#62636c] font-albert-sans mt-1 md:mt-2">
                    {fee.description}
                  </p>
                </div>
                <div className="flex items-center gap-3 shrink-0">
                  <span className="rounded-[8px] border border-[#62636C33] py-1.5 px-3 md:py-[5px] md:px-[10px] text-[15px] md:text-[18px] tracking-[-0.04em] text-[#1c1c1c] font-semibold font-albert-sans group-hover:border-[#122d63]/20 transition-colors duration-200">
                    {fee.price}
                  </span>
                  <span
                    className="rounded-[8px] py-1.5 px-3 md:py-[5px] md:px-[10px] text-[14px] md:text-[16px] tracking-[-0.04em] font-albert-sans whitespace-nowrap font-medium"
                    style={{
                      backgroundColor: fee.badgeColor,
                      color: fee.badgeTextColor,
                    }}
                  >
                    {fee.frequency}
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
